import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Loader from './components/loader/Loader';
import './App.css';
import HomePage from './pages/home/HomePage';
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import SupportChat from "./components/SupportChat/SupportChat";

// Só a home vai no pacote principal; as outras rotas carregam quando abertas.
const HomePageEdit = lazy(() => import("./pages/admin/home-edit/HomePageEdit"));
const Login = lazy(() => import("./pages/admin/login/Login"));
const AdminDashboardPage = lazy(() => import("./pages/admin/dashboard/AdminDashboardPage"));
const ReportsPage = lazy(() => import("./pages/admin/reports/ReportsPage"));
const PrivacyPolicy = lazy(() => import("./pages/terms/privacy-policy/PrivacyPolicy"));
const FloatingNotificationAdmin = lazy(() => import("./components/FloatingNotification/FloatingNotificationAdmin"));
const TermsAndConditions = lazy(() => import("./pages/terms/terms-and-conditions/TermsAndConditions"));
const TermsAndConditionsPromo = lazy(() => import("./pages/terms/terms-and-conditions-promo/TermsAndConditionsPromo"));
const ComplianceForm = lazy(() =>
  import("./pages/compliance-form").then((module) => ({ default: module.ComplianceForm })),
);
const InternetAnapolisPage = lazy(() => import("./pages/seo/InternetAnapolisPage"));
const InternetFibraAnapolisPage = lazy(() => import("./pages/seo/InternetFibraAnapolisPage"));
const InternetEmpresarialAnapolisPage = lazy(() => import("./pages/seo/InternetEmpresarialAnapolisPage"));
const InternetResidencialAnapolisPage = lazy(() => import("./pages/seo/InternetResidencialAnapolisPage"));
const ProvedorInternetAnapolisPage = lazy(() => import("./pages/seo/ProvedorInternetAnapolisPage"));
const StreamingLandingPage = lazy(() => import("./pages/seo/StreamingLandingPage"));
const CityFallbackPage = lazy(() => import("./pages/seo/CityFallbackPage"));
const BlogIndex = lazy(() => import("./pages/blog/BlogIndex"));
const BlogPost = lazy(() => import("./pages/blog/BlogPost"));
const BlogAdminPage = lazy(() => import("./pages/admin/blog/BlogAdminPage"));
const BlogManagePage = lazy(() => import("./pages/admin/blog/BlogManagePage"));
const PromoTermsEditPage = lazy(() => import("./pages/admin/promo-terms-edit/PromoTermsEditPage"));
const BlogNoticeAdmin = lazy(() => import("./components/BlogNoticeAdmin/BlogNoticeAdmin"));

function App() {
  return (
    <Router>
      <div>
        <ScrollToTop />
        <SupportChat />
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/admin/relatorios" element={<ReportsPage />} />
            <Route path="/admin-edit" element={<HomePageEdit />} />
            <Route path="/admin-edit/floating-notification" element={<FloatingNotificationAdmin />} />
            <Route path="/admin-edit/blog-notice" element={<BlogNoticeAdmin />} />
            <Route path="/admin-edit/promo-terms" element={<PromoTermsEditPage />} />
            <Route path="/admin/blog" element={<BlogManagePage />} />
            <Route path="/admin/blog/create" element={<BlogAdminPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/internet-fibra-anapolis" element={<InternetFibraAnapolisPage />} />
            <Route path="/internet-anapolis" element={<InternetAnapolisPage />} />
            <Route
              path="/internet-empresarial-anapolis"
              element={<InternetEmpresarialAnapolisPage />}
            />
            <Route
              path="/internet-residencial-anapolis"
              element={<InternetResidencialAnapolisPage />}
            />
            <Route
              path="/provedor-internet-anapolis"
              element={<ProvedorInternetAnapolisPage />}
            />
            <Route path="/internet-fibra/:citySlug" element={<CityFallbackPage />} />
            <Route path="/streaming/:streamingSlug" element={<StreamingLandingPage />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/terms/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/terms/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route
              path="/terms/terms-and-conditions/promo"
              element={<TermsAndConditionsPromo />}
            />
            <Route path="/compliance" element={<ComplianceForm />} />
            <Route path="*" element={<CityFallbackPage />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
